// Report registry — maps report slugs to their config file names.
// The actual config JSON is loaded from the API at runtime.
// Adding a new report: just add one line here + nav entry in navigationConfig.js.

const reportRegistry = {
  'io-assignments': {
    configId: 'io-assignments',
    label: 'I/O Assignments',
    description: 'Tag IO assignment details by panel, drop, slot, channel'
  },
  'drawing-log': {
    configId: 'drawing-log',
    label: 'Drawing Log',
    description: 'Drawing revision history by source and drawing name'
  },
  'ip-addresses-dln': {
    configId: 'ip-addresses-dln',
    label: 'IP Addresses - DLN',
    description: 'Dynamic LAN device IP address assignments'
  },
  'ip-addresses-sln': {
    configId: 'ip-addresses-sln',
    label: 'IP Addresses - SLN',
    description: 'Secure LAN device IP address assignments'
  },
  'network-connection': {
    configId: 'network-connection',
    label: 'Network Connection Report',
    description: 'ENET network connections by equipment, panel, and port'
  },
  'panel-report': {
    configId: 'panel-report',
    label: 'Panel Report',
    description: 'Tag IO assignments by panel, drop, slot, and channel'
  },
  'oat-report': {
    configId: 'oat-report',
    label: 'OAT Report',
    description: 'Owner Acceptance Testing status by tag'
  },
  'qaqc-report': {
    configId: 'qaqc-report',
    label: 'QAQC Report',
    description: 'Construction QA/QC status by tag'
  },
  'commissioning-status': {
    configId: 'commissioning-status',
    label: 'Commissioning Status Report',
    description: 'Full commissioning status including construction and OAT by tag'
  },
  'index-panels': {
    configId: 'index-panels',
    label: 'Index Report - Panels',
    description: 'Index sheet specifications for panels'
  },
  'index-tags': {
    configId: 'index-tags',
    label: 'Index Report - Tags',
    description: 'Index sheet specifications for tags'
  }
};

export default reportRegistry;

export const getReportMeta = (slug) => reportRegistry[slug] || null;

export const getAllReports = () =>
  Object.entries(reportRegistry).map(([slug, meta]) => ({ slug, ...meta }));
